import { shortenizeFullName } from '@/utils/misc'
import get from "lodash/get";

class FlightOrder {
  id = null

  flightDate = null //ISO DATETIME
  depPortId = null
  arrPortId = null

  cargo = false

  initiatorUserId = null
  orderData = {}
  source = null

  searchString = ''

  workflowProcess = null
  processData = null

  createDate = null // ISO DATETIME
  createUserId = null
  updateDate = null // ISO DATETIME
  updateUserId = null

  hasProcessInstance () {
    return !!(this.workflowProcess || {}).processInstanceId
  }

  /**
   * Used for debug. Or add translates and add more stuff to use it anywhere
   * @returns {string}
   */
  getTitle () {
    let title = ''
    if (this.cargo) {
      const { name, dimensions, packType, placeCount, weight } = this.orderData
      title = `${name} (x${placeCount}) ${packType}(${dimensions}, ${weight}kg)`
    } else {
      const { fullName, docNum } = this.orderData
      const shortName = shortenizeFullName(fullName)
      title = `${shortName}, ${docNum}`
    }
    return title
  }

  getState () {
    return get(this, 'processData.orderStatus', 'noState')
  }

  static assign (json) {
    const flightOrder = Object.assign(new FlightOrder(), json)
    if (!flightOrder.cargo) {
      if (flightOrder.orderData && flightOrder.orderData.firstName) {
        const { orderData } = flightOrder
        orderData.fullName = [orderData.lastName, orderData.firstName, orderData.middleName].filter(str => !!str).join(' ').replace(/\s+/g, ' ')
      }
    }
    return flightOrder
  }
}

export default FlightOrder



// WEBPACK FOOTER //
// ./src/models/flightOrder.js